import { render, staticRenderFns } from "./PageLineEditor.vue?vue&type=template&id=2bf64130&scoped=true"
import script from "./PageLineEditor.vue?vue&type=script&lang=js"
export * from "./PageLineEditor.vue?vue&type=script&lang=js"
import style0 from "./PageLineEditor.vue?vue&type=style&index=0&id=2bf64130&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf64130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf64130')) {
      api.createRecord('2bf64130', component.options)
    } else {
      api.reload('2bf64130', component.options)
    }
    module.hot.accept("./PageLineEditor.vue?vue&type=template&id=2bf64130&scoped=true", function () {
      api.rerender('2bf64130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/PageLineEditor.vue"
export default component.exports